"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Mountain, Feather, Disc3, Youtube, Instagram, Music } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 w-full max-w-[200px]">
        <div className="h-4 w-3/4 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-1/2 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-2/3 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-muted-foreground text-sm italic">Nessun link disponibile.</p>;
  }
  return <ul className="space-y-4 w-full">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground hover:text-foreground transition-colors duration-300 text-sm md:text-base">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background text-foreground pt-20 overflow-hidden relative">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {}
        <div className="flex justify-center mb-20">
          <Link to="/" className="flex items-center gap-6 group" aria-label="Torna alla Home">
            <div className="relative flex items-center justify-center transition-transform duration-700 group-hover:scale-105">
              <Mountain className="size-12 text-muted-foreground group-hover:text-foreground transition-colors duration-500" strokeWidth={1} />
              <Feather className="size-5 text-primary absolute -top-2 -right-3 rotate-45 opacity-90" strokeWidth={1.5} />
            </div>
            <div className="h-10 w-[1px] bg-border/40"></div>
            <Disc3 className="size-11 text-muted-foreground group-hover:text-foreground transition-all duration-700 group-hover:rotate-45" strokeWidth={1} />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 max-w-5xl mx-auto text-center md:text-left mb-20">
          
          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-default text-lg font-medium mb-8 tracking-widest uppercase text-foreground/90 border-b border-border/30 pb-2 inline-block">
              Mappa del Sito
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-default text-lg font-medium mb-8 tracking-widest uppercase text-foreground/90 border-b border-border/30 pb-2 inline-block">
              Social
            </h3>
            <ul className="space-y-5">
              <li data-index={0}>
                <Link to="https://www.youtube.com/@Sacropan" newTab className="flex items-center gap-3 text-foreground hover:text-foreground transition-colors duration-300 group">
                  <Youtube className="size-5 group-hover:text-primary transition-colors" strokeWidth={1.5} /> 
                  <span className="text-sm md:text-base">YouTube</span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" newTab className="flex items-center gap-3 text-foreground hover:text-foreground transition-colors duration-300 group">
                  <Instagram className="size-5 group-hover:text-primary transition-colors" strokeWidth={1.5} /> 
                  <span className="text-sm md:text-base">Instagram</span>
                </Link>
              </li>
              <li data-index={2}>
                <Link to="#" newTab className="flex items-center gap-3 text-foreground hover:text-foreground transition-colors duration-300 group">
                  <Music className="size-5 group-hover:text-primary transition-colors" strokeWidth={1.5} /> 
                  <span className="text-sm md:text-base">Spotify</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-default text-lg font-medium mb-8 tracking-widest uppercase text-foreground/90 border-b border-border/30 pb-2 inline-block">
              Note Legali
            </h3>
            <ul className="space-y-5">
              <li data-index={0}>
                <Link to="#" className="text-foreground hover:text-foreground transition-colors duration-300 text-sm md:text-base">
                  Privacy Policy
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-foreground hover:text-foreground transition-colors duration-300 text-sm md:text-base">
                  Termini di Servizio
                </Link>
              </li>
              <li data-index={2}>
                <Link to="#" className="text-foreground hover:text-foreground transition-colors duration-300 text-sm md:text-base">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {}
      <div className="w-full overflow-hidden border-t border-border/20 py-5 bg-black/40 backdrop-blur-sm">
        <div className="flex w-max animate-marquee">
          {[...Array(12)].map((_, i) => <span key={i} data-index={i} className="mx-8 text-xs md:text-sm tracking-[0.3em] uppercase text-foreground/60 font-serif whitespace-nowrap">
              Per non dimenticare - 1915-1918
            </span>)}
        </div>
      </div>
    </section>;
}